import React, { useEffect, useRef, useState } from "react";
import './InputText.css';
import {
  Box,
  Button,
  Modal,
  Typography
} from '@mui/material';
import { toast } from "react-toastify";

type Props = {
  open: boolean;
  text:  string;
  title: string;
  setOpen: (val: boolean) => void;
  setText: (val: string) => void;
}

const InputText = (props: Props) => {
  const { open, setOpen, setText, text, title } = props;
  const [temp, setTemp] = useState('')
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open) {
      const handleFocus = () => {
        if (inputRef.current) {
          inputRef.current.focus();
          if (inputRef.current.value !== undefined) {
            inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
          }
        }
      };
      setTemp(text)
      const timeoutId = setTimeout(handleFocus, 500); // 웹뷰 로딩 시간을 고려하여 약간의 지연을 줌

      return () => clearTimeout(timeoutId);
    }
  }, [open]);
 
  const handleClose= () => setOpen(false)
  const handleChange = (e: { target: { value: any; }; }) => {
    var regExp = /[{}[\]/;:|)*~`!^\-_+┼<>@#$%&'"\\(=]/gi;
    if( regExp.test(e.target.value) ){
      toast("please try again other text, can't use special characters.");
      return
    }
    setTemp(e.target.value)
  }
  const onClickCancel = () => {
    setTemp('')
    setOpen(false)
  }
  const onClickSave =() => {
    setText(temp)
    setOpen(false)
  }


  return (
      <Modal  open={open} onClose={handleClose}>
        <Box
          sx={[{
            alignItems: "flex-start",
            justifyContent: "center",
            mt: '1.6rem',
            padding: '3.0rem 5.0rem',
            height: '15.6rem',
          }, modal]}
        >
        <Typography sx={{color: '#F72E13', fontSize: '2.2rem', fontWeight: '600'}}>{title}</Typography>
        <input style={{width: '100%', height: '11.6rem', padding: '1.0rem' , fontSize: '3.2rem', fontWeight: '500'}}
          id="myInput"
          ref={inputRef}
          maxLength={100} 
          autoFocus
          placeholder="Enter text here"
          onChange={handleChange}
          onFocus={() => {
            if (inputRef.current && inputRef.current.value !== undefined) {
              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }
          }}
          autoCapitalize='none'
          defaultValue=""
          type="visible-password"
          className="focus-red"
          value={temp}
          autoComplete="off"
          inputMode="text"/>
        <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', mt: '1.6rem'}}>
          <Button  sx={{ background: '#fff', borderRadius: '3.0rem', padding: '.5rem 2.0rem', border: '1px solid #000'}} onClick={() => onClickCancel()}>
            <Typography sx={{fontSize: '2.2rem', fontWeight: '500', color: '#000'}}>Cancel</Typography>
          </Button>
          <Button  sx={{ background: '#F72E13', borderRadius: '3.0rem', padding: '.5rem 4.0rem', ml: '.5rem' , border: '1px solid #F72E13'}} onClick={() => onClickSave()}>
            <Typography sx={{fontSize: '2.2rem', fontWeight: '500', color: '#fff'}}>Save</Typography>
          </Button>
        </Box>
        {/* <Box style={{ position: 'absolute', bottom: '30rem', width: '100%', height: '300rem'}}>
          <Keyboard 
            keyboardRef={r => (keyboard = r)}
            layoutName={"default"}
            theme={"hg-theme-default hg-theme-ios myTheme"}
            onChange={onChange}
            // onKeyPress={onKeyPress}
          />
        </Box> */}
      </Box>
    </Modal>
    );
  }

  const modal = {
    position: 'absolute' as 'absolute',
    top: '35%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '29.6rem',
    bgcolor: 'background.paper',
    // border: '2rem solid #fff',
    borderRadius: '1.5rem',
    boxShadow: '0rem 0rem 5.0rem 0rem rgba(0, 0, 0, 0.40)'
  
  };
export default InputText;
